/* ==========================================================================
   Product page — variant switching, gallery, sticky buy bar
   Everything here is an enhancement; the page is buyable without it.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;

  /* ------------------------------------------------------ variant picker -- */

  if (!customElements.get('variant-picker')) {
    customElements.define(
      'variant-picker',
      class VariantPicker extends HTMLElement {
        connectedCallback() {
          var data = this.querySelector('[data-variant-data]');
          if (!data) return;

          try {
            this.variants = JSON.parse(data.textContent);
          } catch (e) {
            return;
          }

          this.id = this.dataset.id;
          this.addEventListener('change', this.onChange.bind(this));

          // Liquid has already marked what is sold out, so this only has to
          // agree with it. It matters when the markup is reused with a
          // different selection, such as after a section re-render.
          this.markUnavailable(this.selectedValues());
        }

        selectedValues() {
          var values = [];
          this.querySelectorAll('select[data-option-index]').forEach(function (sel) {
            values[parseInt(sel.dataset.optionIndex, 10) - 1] = sel.value;
          });
          this.querySelectorAll('input[type="radio"][data-option-index]:checked').forEach(function (input) {
            values[parseInt(input.dataset.optionIndex, 10) - 1] = input.value;
          });
          return values;
        }

        onChange() {
          var values = this.selectedValues();

          // Reflect the choice in the legend.
          values.forEach(
            function (v, i) {
              var label = this.querySelector('[data-selected-for="' + (i + 1) + '"]');
              if (label) label.textContent = v;
            }.bind(this)
          );

          var match = this.variants.find(function (variant) {
            return variant.options.every(function (opt, i) {
              return values[i] === opt;
            });
          });

          this.markUnavailable(values);
          this.update(match);
        }

        // Strike out combinations that do not exist, rather than letting
        // someone pick their way into a dead end.
        //
        // This used to skip the first option group on the reasoning that it
        // should stay fully selectable. On a costume whose only option is Size,
        // Size *is* the first group — so a sold-out size was never marked at
        // all, which is the one place it matters most.
        markUnavailable(values) {
          var variants = this.variants;

          this.querySelectorAll('input[type="radio"][data-option-index]').forEach(function (input) {
            var i = parseInt(input.dataset.optionIndex, 10) - 1;

            // Offered when some in-stock variant carries this value and agrees
            // with what is chosen in the groups before it. Looking only at the
            // earlier groups is what lets someone change their mind about size
            // without the colour they already picked locking them out.
            var ok = variants.some(function (variant) {
              if (!variant.available) return false;
              if (variant.options[i] !== input.value) return false;
              for (var j = 0; j < i; j++) {
                if (values[j] !== undefined && variant.options[j] !== values[j]) return false;
              }
              return true;
            });

            input.disabled = !ok;
          });
        }

        update(variant) {
          var form = document.getElementById('ProductForm-' + this.id);
          var idInput = form ? form.querySelector('[name="id"]') : null;
          var submit = form ? form.querySelector('[data-buy-submit]') : null;
          var priceEl = document.querySelector('[data-price-for="' + this.id + '"]');
          var stockEl = document.querySelector('[data-stock-for="' + this.id + '"]');

          if (!variant) {
            if (submit) {
              submit.disabled = true;
              submit.textContent = window.tppStrings.unavailable;
            }
            return;
          }

          if (idInput) idInput.value = variant.id;

          if (submit) {
            submit.disabled = !variant.available;
            submit.textContent = variant.available
              ? window.tppStrings.addToCart
              : window.tppStrings.soldOut;
          }

          // Keep the address bar honest so the page can be shared or reloaded.
          if (window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          }

          // Price and stock come back from the section, so money formatting and
          // wording stay in Liquid rather than being rebuilt in JavaScript.
          fetch(this.dataset.url + '?variant=' + variant.id + '&section_id=' + this.dataset.sectionId)
            .then(function (r) {
              return r.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var newPrice = doc.querySelector('[data-price-for]');
              var newStock = doc.querySelector('[data-stock-for]');
              if (newPrice && priceEl) priceEl.innerHTML = newPrice.innerHTML;
              if (newStock && stockEl) stockEl.outerHTML = newStock.outerHTML;
            })
            .catch(function () {
              /* Leave the rendered price alone if the request fails. */
            });

          // Show the media for this variant.
          if (variant.featured_media) {
            var gallery = document.querySelector('[data-gallery]');
            if (gallery) {
              var thumb = gallery.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
              if (thumb) thumb.click();
            }
          }
        }
      }
    );
  }

  /* ------------------------------------------------------------ gallery --- */

  function gallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (g) {
      if (g.dataset.bound) return;
      g.dataset.bound = '1';

      g.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-media-id]');
        if (!thumb) return;

        var id = thumb.getAttribute('data-media-id');

        g.querySelectorAll('[data-media-id]').forEach(function (t) {
          t.setAttribute('aria-current', String(t === thumb));
        });
        g.querySelectorAll('.gallery__slide').forEach(function (slide) {
          slide.classList.toggle('is-active', slide.getAttribute('data-slide-id') === id);
        });
      });

      // Left/right arrows move through the thumbnails.
      g.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-media-id]'));
        var i = thumbs.indexOf(document.activeElement);
        if (i === -1) return;
        e.preventDefault();
        var next = thumbs[e.key === 'ArrowRight' ? i + 1 : i - 1];
        if (next) {
          next.focus();
          next.click();
        }
      });
    });
  }

  /* --------------------------------------------------------- quantity ----- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = (parseInt(input.value, 10) || min) + step;
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* -------------------------------------------------------- sticky bar ---- */

  function stickyBuy() {
    var bar = document.querySelector('[data-sticky-buy]');
    var anchor = document.querySelector('[data-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    if (bar.dataset.bound) return;
    bar.dataset.bound = '1';

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // Show it once the real buy button has scrolled out of view.
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    io.observe(anchor);
  }

  /* ------------------------------------------------------------- share ---- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share]');
    if (!btn) return;
    var url = btn.getAttribute('data-share');

    if (navigator.share) {
      navigator.share({ url: url, title: document.title }).catch(function () {});
      return;
    }

    navigator.clipboard.writeText(url).then(function () {
      var live = btn.parentElement.querySelector('[data-share-status]');
      if (live) live.textContent = window.accessibilityStrings.shareSuccess;
    });
  });

  /* ----------------------------------------------- recommendations ------- */

  // Shopify only fills `recommendations` on a second request, so the section
  // renders an empty shell first and this fetches the real thing.
  function recommendations() {
    document.querySelectorAll('[data-recommendations]').forEach(function (el) {
      if (el.dataset.loaded) return;
      el.dataset.loaded = '1';

      var url = el.getAttribute('data-url');
      if (!url) return;

      fetch(url)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('.section');
          if (section && section.querySelector('.card')) {
            el.replaceWith(section);
            document.dispatchEvent(new CustomEvent('shopify:section:load'));
          } else {
            el.remove();
          }
        })
        .catch(function () {
          el.remove();
        });
    });
  }

  /* -------------------------------------------------------------- init ---- */

  function init() {
    gallery();
    stickyBuy();
    recommendations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
